var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { styled } from '@creditas-ui/system';
import { Box } from './Box';
var Grid = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
Grid.defaultProps = {
  display: 'grid'
};
export { Grid };
//# sourceMappingURL=Grid.js.map